export const EXPORT_FORMATS = [
  { value: "geojson", label: ".geojson" },
  { value: "json", label: ".json" },
  { value: "kml", label: ".kml" },
  { value: "shp", label: ".shp" },
];

// SHP export is not supported for LineString geometry (vegetation pathways)
// due to a library limitation where all features are dissolved into one record.
export const EXPORT_FORMATS_NO_SHP = EXPORT_FORMATS.filter(
  (f) => f.value !== "shp"
);

export const URBAN_DOWNLOAD_TYPES = [
  { value: "aggregate", label: "aggregate data" },
  { value: "aggregate_polygons", label: "Aggregate Data - Polygons" },
  { value: "tree", label: "Single run tree" },
  { value: "nodes", label: "Single run nodes" },
  { value: "polygons", label: "Single Run Polygons" },
];

// All vegetation download layer options (pathways, vector layers, rasters from run JSON)
export const VEGETATION_DOWNLOAD_LAYERS = [
  {
    value: "pathways_baseline",
    label: "Baseline pathways",
    type: "pathway",
    subset: "baseline",
  },
  {
    value: "pathways_override",
    label: "Hypothetical pathways",
    type: "pathway",
    subset: "override",
  },
  {
    value: "pathways_all",
    label: "All pathways",
    type: "pathway",
    subset: "all",
  },
  {
    value: "ignition_lines",
    label: "Ignition Lines",
    type: "vector",
    runKey: "ignition",
  },
  {
    value: "overrides",
    label: "Overrides",
    type: "vector",
    runKey: "overrides",
  },
  {
    value: "suitability",
    label: "Suitability",
    type: "vector",
    runKey: "suitability",
  },
  {
    value: "wind_speed",
    label: "Wind Speed",
    type: "raster",
    runKey: "wind_speed",
  },
  {
    value: "wind_direction",
    label: "Wind Direction",
    type: "raster",
    runKey: "wind_direction",
  },
  {
    value: "arrival_time",
    label: "Arrival Time",
    type: "raster",
    runKey: "arrival_time",
  },
  {
    value: "flame_length",
    label: "Flame Length",
    type: "raster",
    runKey: "flame_length",
  },
  {
    value: "rate_of_spread",
    label: "Rate of Spread",
    type: "raster",
    runKey: "rate_of_spread",
  },
  {
    value: "maxspot_distance",
    label: "Max Spot Distance",
    type: "raster",
    runKey: "maxspot_distance",
  },
  {
    value: "maxspot_direction",
    label: "Max Spot Direction",
    type: "raster",
    runKey: "maxspot_direction",
  },
  {
    value: "arrival_delta",
    label: "Arrival Delta",
    type: "raster",
    runKey: "arrival_delta",
  },
  // Hypothetical rasters live nested under `hypothetical_files` on the run
  // (populated by the backend only when the run has overrides). `source`
  // tells the download control to resolve the URL from there rather than the
  // top-level run object; entries surface only when their URL is present.
  {
    value: "hypothetical_arrival_time",
    label: "Arrival Time (Hypothetical)",
    type: "raster",
    runKey: "hypothetical_arrival_time",
    source: "hypothetical",
  },
  {
    value: "hypothetical_flame_length",
    label: "Flame Length (Hypothetical)",
    type: "raster",
    runKey: "hypothetical_flame_length",
    source: "hypothetical",
  },
  {
    value: "hypothetical_rate_of_spread",
    label: "Rate of Spread (Hypothetical)",
    type: "raster",
    runKey: "hypothetical_rate_of_spread",
    source: "hypothetical",
  },
  {
    value: "hypothetical_maxspot_distance",
    label: "Max Spot Distance (Hypothetical)",
    type: "raster",
    runKey: "hypothetical_maxspot_distance",
    source: "hypothetical",
  },
  {
    value: "hypothetical_maxspot_direction",
    label: "Max Spot Direction (Hypothetical)",
    type: "raster",
    runKey: "hypothetical_maxspot_direction",
    source: "hypothetical",
  },
];

export const NODE_TYPE_SUBSETS = [
  { value: "all", label: "All nodes" },
  { value: "structure", label: "Structure nodes" },
  { value: "vegetation", label: "Vegetation nodes" },
];
